import React from 'react';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.disclosureSection}>
          <p className={styles.disclosure}>
            Preservoir does not provide investment advice. You should ensure that any investment
            made through the platform is suitable for your business's objectives, cash flow needs,
            and risk tolerance.
          </p>
          <p className={styles.smallPrint}>
            All rights reserved. Preservoir is a trading name of Preservoir Ltd, a company
            registered in Northern Ireland with company number NI727964 and authorised and regulated
            by the Financial Conduct Authority. Information about us can be found on the Financial
            Services Register (register number 1032785). Registered Office: 65-69 Dublin Road,
            Belfast, Northern Ireland, BT2 7HG
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
